var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "comment__more",
      attrs: { id: _vm.comment.id },
      on: {
        click: function($event) {
          _vm.commentActionsShow = !_vm.commentActionsShow
        }
      }
    },
    [
      _c("div", { staticClass: "comment__more-icon" }),
      _vm._v(" "),
      _vm.commentActionsShow
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.commentActions,
                  expression: "commentActions"
                }
              ],
              staticClass: "comment-actions"
            },
            [
              _c("div", { staticClass: "comment-actions__inner" }, [
                _vm.comment.belongsToUser
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "comment-actions__item comment-actions__item-edit",
                        on: { click: _vm.edit }
                      },
                      [_vm._v("\n                Изменить\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.comment.belongsToUser
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "comment-actions__item comment-actions__item-delete",
                        on: { click: _vm.remove }
                      },
                      [_vm._v("\n                Удалить\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.comment.belongsToUser
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "comment-actions__item comment-actions__item-complain",
                        on: { click: _vm.complain }
                      },
                      [_vm._v("\n                Пожаловаться\n            ")]
                    )
                  : _vm._e()
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }